/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/120-quotes-left': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M3.516 7a3.5 3.5 0 11-3.5 3.5L0 10a7 7 0 017-7v2a4.97 4.97 0 00-3.536 1.464 5.01 5.01 0 00-.497.578c.179-.028.362-.043.548-.043zm9 0a3.5 3.5 0 11-3.5 3.5L9 10a7 7 0 017-7v2a4.97 4.97 0 00-3.536 1.464 5.01 5.01 0 00-.497.578c.179-.028.362-.043.549-.043z"/>'
  }
})
